import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';

interface LanguageFormViewProps extends ComponentViewProps<LanguageItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	onFlagChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
	contextService: any;
}

@observer
export class LanguageFormView extends React.Component<LanguageFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) {
			return null;
		}

		const mode = this.props.mode;
		const displayNames = model.dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [{ title: 'Title', dynamicProperties: displayNames, required: true }];
		const noflag = 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAHZSURBVEhLxZW7jsJADEU9QTwaGhqE+ADEo0dIUPLVNPwDCAQtIOh5v5czi0PE7mYmxYorWTOx79g3licxvV7vLh9E8Fw/Bm8B9/vdmgu+PIWXgNvtZtfL5RKbnBgcoGdccArQN+p2u9JsNmW/3/8qAh8xOHD1nAuBEv+y8/ksrVbLkguFgrTb7VBE1PARgwM4w9l33rsFtCrOgiCQfr8v2+3WJqZAp9OR3W4n1+vVGnt8WhwuZzj7W86omfF47OwTSo/Ho9RqNclkMtbH82QysftKpSLZbNbuT6eTjEYj+2yMsb44mMFg4D2ytBQRWmy9Xts1n8/bFVEUT6fT9tkHZjgcegugE4ioVquSy+We3m8cDgd5dNMW93lzRaIPEYkp8BD99LyAL2lxkEiAdqDRaDw9L+DTqU8C5zWMms6Atp8Z0DnAR0xF+JqXAK4Liev1ejiAm81GptOpNfaAGJwkIsx8Pnf2DAHlctnea8DArVarcNopWCqVQnHwF4tFyI+DswN824vF4o/iqVQq5LBfLpc2BuByRv8dceaUSDIKgmjx6LSzx0dMRbD36YCZzWZeX0JAa0n611WDpxzgcyXdEh/QRHHFAbEkxYGXAEBCn6S+PIW3gP+ByBfxJS5nmEXtPwAAAABJRU5ErkJggg==';
		const flag = model.flag != null && model.flag.length > 0 ? btoa(String.fromCharCode.apply(null, model.flag)) : noflag;

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={this.props.mode}
							icon="book"
							title="General information">
							<Row gutter={16}>
								<Col xs={24}>
									<TextView
										mode={mode}
										label="Code"
										required
										value={model.languageCode}
										onChanged={newVal => {
											model.languageCode = newVal;
										}}
										addonClass="addon-button"
										addonAfter={
											<label style={{ cursor: 'pointer' }} htmlFor='flag' className="text-center">
												<img src={'data:image/png;base64,' + flag} width="32" height="20" />
												<input id="flag" type="file" style={{ display: 'none' }} accept="image/png" onChange={this.props.onFlagChange} />
											</label>
										}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<TabLanguageController
										model={model}
										dynamicProperties={array}
										mode={mode}
										setBusy={this.props.setBusy}
										isRichTextBox={false}
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}

 //data-bind="event: { change: $parents[1].getFileContent }"



// WEBPACK FOOTER //
// ./src/app/general/language/form/language-form.view.tsx